import { FormikHelpers } from "formik";
import { useState } from "react";
import ApiClient from "../../../../../api";
import {
  UnprocessableEntityError,
  UnprocessableEntityErrorItem,
} from "../../../../../errors";
import { useBoronMutation } from "../../../../../hooks/http/useBoronMutation";
import SectionInterface from "../../../../../interfaces/SectionInterface";
import type { paths } from "../../../../../lib/api/v1";

const path =
  "/api/v1/sections/{section_id}/import/student_passcode_inactivations/confirmation";

type ConfirmationResponse =
  paths[typeof path]["post"]["responses"]["200"]["content"]["application/json"];

export type Values = { csv: Blob | undefined };

export const useStudentPasscodeInactivationConfirmation = (
  section: SectionInterface,
) => {
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [csvData, setCsvData] = useState<ConfirmationResponse | null>(null);
  const [csvFile, setCsvFile] = useState<Blob | null>(null);
  const apiPath = path.replace("{section_id}", section.id);

  const importConfirmationTargetPeople = (
    { csv }: Values,
    formikHelpers: FormikHelpers<Values>,
  ) => {
    if (csv === undefined) {
      return;
    }

    mutateAsync(csv)
      .then(() => {
        formikHelpers.setSubmitting(false);
      })
      .catch((error) => {
        formikHelpers.setSubmitting(false);
        if (
          error instanceof UnprocessableEntityError &&
          formikHelpers?.setFieldError
        ) {
          setErrors(formikHelpers.setFieldError, error.originalErrors);
        }
      });
  };

  const setErrors = (
    setFieldError: FormikHelpers<Values>["setFieldError"],
    errors: UnprocessableEntityErrorItem[],
  ) => {
    errors.forEach((error) => {
      setFieldError("csv", error.message);
    });
  };

  const { mutateAsync } = useBoronMutation<ConfirmationResponse, Blob>(
    async (csv) => {
      setCsvFile(csv);
      const response = await ApiClient.sendFormData(apiPath, "POST", { csv });
      return { response, data: response.ok && (await response.json()) };
    },
    {
      onSuccess: (data) => {
        setCsvData(data);
        setIsConfirmModalOpen(true);
      },
    },
  );

  return {
    isConfirmModalOpen,
    csvData,
    csvFile,
    importConfirmationTargetPeople,
    handleCloseModal: () => setIsConfirmModalOpen(false),
    setIsConfirmModalOpen,
  };
};
